import React, { useState } from 'react';
import { useToast } from '../../../providers/ToastProvider';
import { Toast, ToastInput } from '../../components/Toast';
import { useAppSelector } from '../store';

export default function ToastContainer() {
  const key = useAppSelector(state => state.toasts.key);
  const { toasts } = useToast();
  const [hovering, setHovering] = useState(false);

  // if (!toasts.size) return null;

  const extraToasts = new Map<string, ToastInput>([
    // ['1', { type: ToastType.success, title: '1 updated successfully!' }],
    // ['12', { type: ToastType.success, title: '12 updated successfully!' }],
    // ['123', { type: ToastType.success, title: '123 updated successfully!' }],
    // ['1234', { type: ToastType.success, title: '1234 updated successfully!' }],
    // ['12345', { type: ToastType.success, title: '12345 updated successfully!' }],
    // ['123456', { type: ToastType.success, title: '123456 updated successfully!' }],
    // ['1234567', { type: ToastType.success, title: '1234567 updated successfully!' }],
    // ['12345678', { type: ToastType.success, title: '12345678 updated successfully!' }],
  ]);

  const flatToasts = [...extraToasts.entries(), ...toasts.entries()].reverse().map(([key, value]) => {
    return { id: key, toast: value };
  });

  const shownToasts = flatToasts.slice(0, 3);
  if (!shownToasts.length) return null;

  return (
    <div className='' onMouseEnter={event => setHovering(true)} onMouseLeave={event => setHovering(false)}>
      {hovering ? (
        <div className='fixed bottom-16 left-6 z-50 grid gap-2'>
          {flatToasts.reverse().map((toast, index) => (
            <Toast key={toast.id} offset={0} position='relative' id={toast.id} {...toast.toast} />
          ))}
        </div>
      ) : (
        <>
          {shownToasts[0] && <Toast offset={0} id={shownToasts[0].id} {...shownToasts[0].toast} />}
          {shownToasts[1] && <Toast offset={1} id={shownToasts[1].id} {...shownToasts[1].toast} />}
          {shownToasts[2] && <Toast offset={2} id={shownToasts[2].id} {...shownToasts[2].toast} />}
        </>
      )}
    </div>
  );
}
